import * as queryString from 'query-string'

import Base from './base'
import { Template, Sort } from '../types/template'

type Query = {
  page?: number
  query?: string
  reverse?: boolean
  sort?: Sort
  trim_body_to?: number
  plaintext?: boolean
  page_results?: boolean
}

export type TeamQuery = Query & {
  filter_include_archived?: boolean
  filter_group_ids?: number[]
}

export type EmailQuery = Query & {
  include_team_templates?: boolean
  hide_signature?: boolean
  filter_owners?: number[]
}

type TeamTemplatesResponse = {
  team_templates: Template[]
}

type TemplatesData = {
  templates: Template[]
}

export default class MelodyEmailTemplates extends Base {
  show(id: number) {
    return this.api.get(`email_templates/${id}`)
  }

  search(query: EmailQuery): Promise<TemplatesData> {
    return this.api.get(
      `email_templates_v2.json?${queryString.stringify(query, {
        arrayFormat: 'bracket',
      })}`
    )
  }

  async getTeamTemplates(query: TeamQuery): Promise<TemplatesData> {
    return this.api
      .get(`team_templates.json?${queryString.stringify(query, { arrayFormat: 'bracket' })}`)
      .then(({ team_templates, ...rest }: TeamTemplatesResponse) => ({
        templates: team_templates,
        ...rest,
      }))
  }
}
